<template>
  <div :class="classes">
    <div class="mxl_paging_main" v-if="pagingTotal">共{{total}}条</div>
    <div class="mxl_paging_single" v-if="sizes" v-closeOut="closePS">
      <div class="mxl_paging_single_select" v-if="showPageSelect">
        <div
          class="mxl_paging_single_list"
          v-for="(num, index) in pageNumberList"
          :key="index"
          @mousedown="setNumber(num, $event)"
        >{{num}}</div>
      </div>
      <div
        class="mxl_paging_single_number mxl_paging_main"
        @click="showPageSelect = !showPageSelect"
      >
        <input :value="'每页'+nowPageSize+'项'" type="text" readonly />
      </div>
      <!-- @blur="showPageSelect = false" -->
    </div>
    <div class="mxl_paging_main" @click="prevPage">
      <span v-if="!!pagePrev">{{pagePrev}}</span>
      <i v-if="!pagePrev" class="iconfont icon-icon-test4"></i>
    </div>
    <div class="mxl_paging_number_list">
      <div
        class="mxl_paging_number mxl_paging_main mxl_paging_btn"
        :class="{active: nowPage==item, rightArrow: item == -2, leftArrow: item == -1 }"
        v-for="item in pageList"
        :key="item"
        @click="changepage(item)"
      >
        {{item | pageFilter}}
        <!-- <span
          :class="{'iconfont icon-shuangzuojiantou-': item == -1, 'iconfont icon-shuangyoujiantou-': item == -2}"
        ></span>-->
      </div>
    </div>
    <div class="mxl_paging_main" @click="nextPage">
      <span v-if="!!pageNext">{{pageNext}}</span>
      <i v-if="!pageNext" class="iconfont icon-icon-test6"></i>
    </div>
  </div>
</template> 

<script>
// import { backgroundCheck } from "@/utils/type.js";
// import closeOut from "@/mixins/closeOut.js";
export default {
  props: {
    total: {
      //总数
      type: Number,
      default: 0
    },
    pagePrev: {
      //前一页
      type: String,
      default: ""
    },
    pageNext: {
      //后一页
      type: String,
      default: ""
    },
    pageNumberList: {
      //显示几条
      type: Array,
      default: function() {
        return [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
      }
    },
    page: {
      //当前页
      type: Number,
      default: 1
    },
    sizes: {
      //是否显示 每页条数控制
      type: Boolean,
      default: false
    },
    pageSize: {
      //每页显示条数
      type: Number,
      default: 10
    },
    background: {
      type: [Boolean, String],
      default: false
    },
    radius: {
      type: Boolean,
      default: false
    }
  },
  // mixins: [closeOut],
  data() {
    return {
      showPageSelect: false,
      // pageList: [],
      allPage: 0,
      nowPageSize: 10,
      nowPage: 1
    };
  },
  directives: {
    closeOut: {
      bind(el, binding, vnode) {
        function documentHandler(e) {
          if (el.contains(e.target)) {
            return false;
          }
          if (binding.expression) {
            binding.value(e);
          }
        }

        function KeyUp(e) {
          if (e.keyCode == 27) {
            if (binding.expression) {
              binding.value(e);
            }
          }
        }
        el.__vueClickOutSize__ = documentHandler;
        el.__vueKeyup__ = KeyUp;

        document.addEventListener("keyup", KeyUp);
        document.addEventListener("click", documentHandler);
      },
      unbind(el, binding) {
        document.removeEventListener("click", el.__vueClickOutSize__);
        delete el.__vueClickOutSize__;

        document.removeEventListener("keyup", el.__vueKeyup__);
        delete el.__vueKeyup__;
      }
    }
  },
  methods: {
    closePS() {
      this.showPageSelect = false;
    },
    setNumber(num, e) {
      e.preventDefault();
      this.showPageSelect = false;
      this.nowPageSize = num;
      // this.allPage = Math.ceil(this.total / num);
      // if (this.nowPage > this.allPage) {
      //   this.nowPage = this.allPage;
      // }
    },
    changepage(item) {
      if (item == -1) {
        if (this.page - 10 < 1) {
          item = 1;
        } else {
          item = this.page - 10;
        }
      } else if (item == -2) {
        if (this.page + 10 <= this.allPage) {
          item = this.page + 10;
        } else {
          item = this.allPage;
        }
      }
      this.nowPage = item;
    },
    prevPage() {
      if (this.nowPage >= 2) {
        this.nowPage--;
      }
    },
    nextPage() {
      if (this.nowPage < this.allPage) {
        this.nowPage++;
      }
    },
    backgroundCheck(val) {
      //用于分页 按钮显示背景判断 string boolean
      if (typeof val === "string") {
        return true;
      } else if (typeof val === "boolean") {
        return val;
      } else {
        return false;
      }
    }
  },
  // mounted() {
  //   if (typeof this.page === "number" && this.page > 0) {
  //     this.nowPage = this.page;
  //   } else {
  //     this.nowPage = 1;
  //   }
  //   if (typeof this.pageSize === "number" && this.pageSize > 0) {
  //     this.nowPageSize = this.pageSize;
  //   } else {
  //     this.nowPageSize = 10;
  //   }
  // },
  watch: {
    page: {
      immediate: true,
      handler(newValue) {
        if (typeof this.page === "number" && this.page > 0) {
          this.nowPage = this.page;
        } else {
          this.nowPage = 1;
        }
      }
    },
    pageSize: {
      immediate: true,
      handler(newValue) {
        if (typeof this.pageSize === "number" && this.pageSize > 0) {
          this.nowPageSize = this.pageSize;
        } else {
          this.nowPageSize = 10;
        }
      }
    },
    // total(newValue, oldValue) {
    // this.allPage = Math.ceil(this.total / this.nowPageSize);
    // if (this.allPage > 12) {
    //   this.pageList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, -2, this.allPage];
    // } else {
    //   this.pageList = [];
    //   for (let pageIndex = 1; pageIndex <= this.allPage; pageIndex++) {
    //     this.pageList.push(pageIndex);
    //   }
    // }
    // },
    nowPageSize(newValue, oldValue) {
      this.$emit("update:pageSize", newValue);
      this.allPage = Math.ceil(this.total / newValue);
      if (this.nowPage > this.allPage) {
        this.nowPage = this.allPage;
      }
      this.$emit("changepagesize", newValue);

      // if (this.allPage > 12) {
      //   this.pageList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, -2, this.allPage];
      // } else {
      //   this.pageList = [];
      //   for (let pageIndex = 1; pageIndex <= this.allPage; pageIndex++) {
      //     this.pageList.push(pageIndex);
      //   }
      // }
    },
    nowPage: {
      // immediate: true,
      handler(newValue) {
        this.$emit("update:page", newValue);
        this.allPage = Math.ceil(this.total / this.nowPageSize);
        this.$emit("changepage", newValue);
      }
    }

    // if (this.allPage > 12) {
    //   if (newValue <= 6) {
    //     this.pageList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, -2, this.allPage];
    //   } else if (this.allPage - newValue < 6) {
    //     this.pageList = [
    //       1,
    //       -1,
    //       this.allPage - 9,
    //       this.allPage - 8,
    //       this.allPage - 7,
    //       this.allPage - 6,
    //       this.allPage - 5,
    //       this.allPage - 4,
    //       this.allPage - 3,
    //       this.allPage - 2,
    //       this.allPage - 1,
    //       this.allPage
    //     ];
    //   } else if (newValue > 6 && this.allPage - newValue >= 6) {
    //     this.pageList = [
    //       1,
    //       -1,
    //       newValue - 3,
    //       newValue - 2,
    //       newValue - 1,
    //       newValue,
    //       newValue + 1,
    //       newValue + 2,
    //       newValue + 3,
    //       newValue + 4,
    //       -2,
    //       this.allPage
    //     ];
    //   }
    // } else {
    //   this.pageList = [];
    //   for (let pageIndex = 1; pageIndex <= this.allPage; pageIndex++) {
    //     this.pageList.push(pageIndex);
    //   }
    // }
  },
  computed: {
    classes() {
      return [
        "mxl_paging",
        {
          [`mxl_paging_bg`]: this.backgroundCheck(this.background),
          [`mxl_paging_radius`]: this.radius
        }
      ];
    },
    pagingTotal() {
      if (typeof this.total === "number" && this.total >= 0) {
        return true;
      } else {
        return false;
      }
    },
    pageList() {
      let array = [];

      let allPage = Math.ceil(this.total / this.nowPageSize) || this.allPage;
      // this.allPage = allPage;
      // allPage = Math.ceil(this.total / this.nowPageSize);

      if (allPage > 12) {
        if (this.nowPage <= 6) {
          array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, -2, allPage];
        } else if (allPage - this.nowPage < 6) {
          array = [
            1,
            -1,
            allPage - 9,
            allPage - 8,
            allPage - 7,
            allPage - 6,
            allPage - 5,
            allPage - 4,
            allPage - 3,
            allPage - 2,
            allPage - 1,
            allPage
          ];
        } else if (this.nowPage > 6 && allPage - this.nowPage >= 6) {
          array = [
            1,
            -1,
            this.nowPage - 3,
            this.nowPage - 2,
            this.nowPage - 1,
            this.nowPage,
            this.nowPage + 1,
            this.nowPage + 2,
            this.nowPage + 3,
            this.nowPage + 4,
            -2,
            allPage
          ];
        }
      } else {
        for (let pageIndex = 1; pageIndex <= allPage; pageIndex++) {
          array.push(pageIndex);
        }
      }
      return array;
    }
  },
  filters: {
    pageFilter: function(value) {
      if (value == -1 || value == -2) {
        return "···";
      } else {
        return value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
//mxl_paging 分页
.mxl_paging {
  width: auto;
  max-width: 100%;
  height: 50px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  .mxl_paging_main {
    width: auto;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 16px;
    padding: 0 5px;
    position: relative;
    cursor: pointer;
  }

  .mxl_paging_single {
    position: relative;

    .mxl_paging_single_select {
      background-color: #ffffff;
      width: auto;
      height: auto;
      max-height: 160px;
      position: absolute;
      border: 1px solid rgba(0, 0, 0, 0.1);
      bottom: 100%;
      left: 0;
      right: 0;
      margin: auto;
      padding: 5px 0;
      overflow: auto;
      z-index: 99;

      .mxl_paging_single_list {
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: text;
        padding: 0 10px;
        cursor: pointer;

        &:hover {
          background-color: #1797f2;
          color: #ffffff;
        }
      }
    }

    .mxl_paging_single_number {
      width: 100px;

      input {
        width: 100%;
        height: 30px;
        border: 0;
        background-color: transparent;
        line-height: 30px;
        font-size: 16px;
        outline: none;
        cursor: pointer;
      }
    }
  }

  .mxl_paging_number_list {
    display: flex;

    .mxl_paging_number {
      &:hover {
        color: #1797f2;
        font-weight: bold;
        background-color: #ffffff;
      }

      &.active {
        background: #1797f2;
        color: #ffffff;
      }

      &.rightArrow {
        position: relative;

        &:hover {
          color: transparent;

          &::after {
            content: ">>>";
            position: absolute;
            width: 100%;
            height: 100%;
            color: #f0932b;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            font-size: 12px;
          }
        }
      }

      &.leftArrow {
        position: relative;

        &:hover {
          color: transparent;

          &::after {
            content: "<<<";
            position: absolute;
            width: 100%;
            height: 100%;
            color: #f0932b;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            font-size: 12px;
          }
        }
      }

      // span {
      //   &.iconfont {
      //     display: none;
      //   }

      // }
    }
  }

  .mxl_paging_btn {
    width: 30px;
  }
}
</style>